import { SERVICE_REQUEST_STATUS, SERVICE_REQUEST_TYPE } from "./constants";
import { STAFF_REAL_ESTATE_ACTIONS } from "./staffRealEstateApi";

/**
 * Staff lifecycle actions for Real Estate only (Phase B.5).
 * Mirrors StatusTransitionService::$realEstate allowed moves.
 */
export function getServiceRequestActions(type, status) {
  if (type && type !== SERVICE_REQUEST_TYPE.REAL_ESTATE) {
    return [];
  }

  const map = {
    [SERVICE_REQUEST_STATUS.SUBMITTED]: [
      { label: "Mark awaiting contact", action: STAFF_REAL_ESTATE_ACTIONS.awaitingContact, variant: "ghost" },
      { label: "Start processing", action: STAFF_REAL_ESTATE_ACTIONS.markContacted, variant: "outline" },
      { label: "Schedule inspection", action: "schedule", variant: "primary" },
      { label: "Decline", action: "decline", variant: "danger" },
    ],
    [SERVICE_REQUEST_STATUS.AWAITING_CONTACT]: [
      { label: "Start processing", action: STAFF_REAL_ESTATE_ACTIONS.markContacted, variant: "success" },
      { label: "Schedule inspection", action: "schedule", variant: "primary" },
      { label: "Awaiting customer", action: STAFF_REAL_ESTATE_ACTIONS.awaitingCustomer, variant: "outline" },
      { label: "Decline", action: "decline", variant: "danger" },
    ],
    [SERVICE_REQUEST_STATUS.IN_PROGRESS]: [
      { label: "Schedule inspection", action: "schedule", variant: "primary" },
      { label: "Awaiting customer", action: STAFF_REAL_ESTATE_ACTIONS.awaitingCustomer, variant: "outline" },
      { label: "Decline", action: "decline", variant: "danger" },
    ],
    [SERVICE_REQUEST_STATUS.AWAITING_CUSTOMER]: [
      { label: "Resume processing", action: STAFF_REAL_ESTATE_ACTIONS.markContacted, variant: "outline" },
      { label: "Schedule inspection", action: "schedule", variant: "primary" },
      { label: "Decline", action: "decline", variant: "danger" },
    ],
    [SERVICE_REQUEST_STATUS.INSPECTION_SCHEDULED]: [
      { label: "Complete inspection", action: STAFF_REAL_ESTATE_ACTIONS.completeInspection, variant: "success" },
      { label: "Reschedule inspection", action: "schedule", variant: "outline" },
      { label: "Cancel inspection", action: STAFF_REAL_ESTATE_ACTIONS.cancelInspection, variant: "ghost" },
      { label: "Decline", action: "decline", variant: "danger" },
    ],
    [SERVICE_REQUEST_STATUS.INSPECTION_COMPLETED]: [
      { label: "Approve", action: STAFF_REAL_ESTATE_ACTIONS.approve, variant: "success" },
      { label: "Awaiting customer", action: STAFF_REAL_ESTATE_ACTIONS.awaitingCustomer, variant: "outline" },
      { label: "Decline", action: "decline", variant: "danger" },
    ],
    [SERVICE_REQUEST_STATUS.APPROVED]: [
      { label: "Complete request", action: STAFF_REAL_ESTATE_ACTIONS.complete, variant: "success" },
      { label: "Cancel", action: "cancel", variant: "danger" },
    ],
    [SERVICE_REQUEST_STATUS.COMPLETED]: [],
    [SERVICE_REQUEST_STATUS.DECLINED]: [],
    [SERVICE_REQUEST_STATUS.CANCELLED]: [],
  };

  return map[status] || [];
}

export function getRecommendedServiceRequestAction(type, status) {
  const actions = getServiceRequestActions(type || SERVICE_REQUEST_TYPE.REAL_ESTATE, status);
  const first = actions[0];
  if (!first) {
    return {
      label: "No action required",
      description: "This request is closed or awaiting no staff action.",
    };
  }
  return {
    label: first.label,
    description: "Recommended next step for this real-estate request.",
    variant: first.variant,
  };
}
